import { useEffect, useState } from "react";
import TodayTable from "../components/TodayTable";
import { Order } from "../network/TableApi/tableInterfaces";
import { getOverall } from "../network/TableApi/tableApi";
interface IProps {}

const TodayPage = (props: IProps) => {
  const [overall, setOverall] = useState<Order>();

  useEffect(() => {
    getOverall().then((data) => setOverall(data));
  }, []);
  return (
    <div>
      <div className="flex justify-between flex-row">
        <p>
          Заработок за все время: <b>{overall?.factInc}%</b> /{" "}
          <b>${overall?.amountMins}</b>
        </p>
      </div>

      <TodayTable />
    </div>
  );
};

export default TodayPage;
